import React from 'react';
import PropTypes from 'prop-types';
import { useWizard } from '@zillow/zrs-rental-applications';
import { TextButton } from '@zillow/constellation';
import { ACCESS_UNAVAILABLE_STEP, ERROR_STEP, LANDING_STEP } from '../../ApplicationManagerModal.util';
import { getIsOnlyAdmin } from '../../../../utils/businessVerification';

export default function CancelButton({ onClose, employees }) {
  const { currentStep, onRequestStep } = useWizard();
  const isOnlyAdmin = getIsOnlyAdmin(employees);
  if (currentStep === ACCESS_UNAVAILABLE_STEP || currentStep === ERROR_STEP) {
    return null;
  }
  if (currentStep === LANDING_STEP && !isOnlyAdmin) {
    return <TextButton onClick={() => onRequestStep(ACCESS_UNAVAILABLE_STEP)}>Not right now</TextButton>;
  }
  return <TextButton onClick={onClose}>Cancel</TextButton>;
}

CancelButton.propTypes = {
  onClose: PropTypes.func.isRequired,
  employees: PropTypes.array,
};
